import { auth } from "../firebase";

export const getAuthToken = async (): Promise<string | null> => {
  try {
    const user = auth.currentUser;
    if (!user) {
      if (process.env.NODE_ENV === "development") {
        console.warn("No authenticated user found");
      }
      return null;
    }

    if (process.env.NODE_ENV === "development") {
      console.log("👤 User:", {
        email: user.email,
        uid: user.uid,
        emailVerified: user.emailVerified
      });
    }

    const token = await user.getIdToken(true);

    if (process.env.NODE_ENV === "development") {
  console.log("🔑 Auth token obtained");
}

    return token;
  } catch (error) {
    console.error("Error getting auth token:", error);
    return null;
  }
};

export const waitForAuth = (): Promise<any> => {
  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (process.env.NODE_ENV === "development") {
        console.log("🔥 Auth state changed in waitForAuth:", user?.email);
      }
      unsubscribe();
      resolve(user);
    });

    setTimeout(() => {
      unsubscribe();
      resolve(null);
    }, 5000);
  });
};

export const getCurrentUser = () => {
  return auth.currentUser;
};

export const getCurrentUserId = (): string | null => {
  return auth.currentUser?.uid || null;
};